import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "results", "hiddenId"]
  static values = { searchUrl: String, createUrl: String }

  connect() {
    this.timeout = null
    this.handleClickOutside = this.clickOutside.bind(this)
    document.addEventListener("click", this.handleClickOutside)
  }

  disconnect() {
    document.removeEventListener("click", this.handleClickOutside)
  }

  search() {
    clearTimeout(this.timeout)
    const query = this.inputTarget.value.trim()

    if (query.length < 2) {
      this.hideResults()
      return
    }

    if (this.hasHiddenIdTarget) this.hiddenIdTarget.value = ""
    this.inputTarget.classList.remove("location-selected")

    this.timeout = setTimeout(() => {
      this.fetchResults(query)
    }, 200)
  }

  async fetchResults(query) {
    const url = `${this.searchUrlValue}?q=${encodeURIComponent(query)}`

    try {
      const response = await fetch(url, {
        headers: { "Accept": "application/json" }
      })
      if (!response.ok) { this.hideResults(); return }

      const data = await response.json()
      this.showResults(data)
    } catch {
      this.hideResults()
    }
  }

  showResults(items) {
    if (items.length === 0) {
      this.resultsTarget.innerHTML = `<div class="search-no-results">No locations found</div>`
      this.resultsTarget.classList.remove("hidden")
      return
    }

    this.resultsTarget.innerHTML = items.map(item => `
      <div class="search-select-item" data-action="click->location-search#select" data-place='${JSON.stringify(item).replace(/'/g, "&#39;")}'>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
          <circle cx="12" cy="10" r="3"></circle>
        </svg>
        <span class="search-result-name">${this.escapeHtml(item.display)}</span>
      </div>
    `).join("")

    this.resultsTarget.classList.remove("hidden")
  }

  async select(event) {
    const place = JSON.parse(event.currentTarget.dataset.place)
    this.inputTarget.value = place.display
    this.hideResults()

    try {
      const token = document.querySelector("meta[name=csrf-token]")?.content
      const response = await fetch(this.createUrlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": token
        },
        body: JSON.stringify({
          city: place.city,
          state: place.state,
          country: place.country,
          latitude: place.latitude,
          longitude: place.longitude
        })
      })

      if (response.ok) {
        const data = await response.json()
        if (this.hasHiddenIdTarget) this.hiddenIdTarget.value = data.location_id
        this.inputTarget.value = data.display
        this.inputTarget.classList.add("location-selected")
      }
    } catch {
      // Keep display text; location_id won't be set
    }
  }

  hideResults() {
    this.resultsTarget.innerHTML = ""
    this.resultsTarget.classList.add("hidden")
  }

  blur() {
    setTimeout(() => { this.resultsTarget.classList.add("hidden") }, 200)
  }

  focus() {
    if (this.inputTarget.value.trim().length >= 2 && this.resultsTarget.innerHTML.trim() !== "") {
      this.resultsTarget.classList.remove("hidden")
    }
  }

  clickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.resultsTarget.classList.add("hidden")
    }
  }

  escapeHtml(text) {
    const div = document.createElement("div")
    div.textContent = text
    return div.innerHTML
  }
}
